/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BladderIrrigationTerminateAliases {
  AUTOCOMPLETE_LIQUID_ASPECT = 'autocomplete-liquid-aspect',
  DATE_HOUR_INPUT = 'date-hour-input',
  FETCH_LIQUID_ASPECT = 'fetch-liquid-aspect',
  FIELD_DATE_TERMINATE = 'field-date-terminate',
  FIELD_DRAINED_VOLUME = 'field-drained-volume',
  FIELD_INFUSED_VOLUME = 'field-infused-volume',
  FIELD_LIQUID_ASPECT = 'field-liquid-aspect',
  FIELD_TEXT_AREA_OBSERVATION = 'field-text-area-observation',
  FORM_CONTENT = 'form-content',
  FRAGMENT_REFERENCE_TITLE = 'fragment-reference-title',
  INPUT_DRAINED_VOLUME = 'input-drained-volume',
  INPUT_INFUSED_VOLUME = 'input-infused-volume',
  MAPPER_LIQUID_ASPECT = 'mapper-liquid-aspect',
  PANEL_CONTENT = 'panel-content',
  PANEL_HEADER = 'panel-header',
  TERMINATE_BLADDER_IRRIGATION_LAYOUT = 'terminate-bladder-irrigation-layout',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TEXT_LIQUID_ASPECT = 'text-liquid-aspect',
}
export { BladderIrrigationTerminateAliases };
